export const pspLimitsSettingsFormRules = {
  currency: { required: true, message: 'Please select currency', trigger: 'change' },
  limitValue: { required: true, message: 'Limit value required', trigger: 'blur' },
};
